<div class="flex flex-col gap-4">
  <div class="w-full h-[1px] bg-surface-200"></div>
  <!-- No column gap so the coloured cells sit flush, matching the cost bubble colours -->
  <div class="grid w-fit p-2 text-text-color text-sm font-normal font-['Inter'] leading-5"
       [style.grid-template-columns]="'auto repeat(' + (columnCount() - 1) + ', 1fr)'"
       [attr.data-testid]="mode() === 'prepayment' ? 'prepayment-table' : 'day-trip-payment-table'">
    <div class="py-1 pr-3"><b>Traveller</b></div>
    <div class="py-1 px-3 text-right"><b>Portion of Total TA Value</b></div>
    @if (showPrepayment()) {
      <div class="py-1 px-3 text-right"><b>Prepayment Component</b></div>
    }
    @if (showFinalisation()) {
      <div class="py-1 px-3 text-right"><b>Finalisation Payment Amount</b></div>
    }
    @if (showDayTrip()) {
      <div class="py-1 px-3 text-right"><b>Day Trip Payment Amount</b></div>
    }
    <div class="col-span-full h-[1px] bg-surface-200"></div>
    @for (row of rows(); track $index) {
      <div class="py-2 pr-3">{{ row.travellerName }}</div>
      <div class="py-2 px-3 text-right">{{ row.portion | currency }}</div>
      @if (showPrepayment()) {
        <div class="py-2 px-3 text-right bg-green-100" [class.font-semibold]="!showFinalisation()">{{ (row.prepaymentAmount ?? 0) | currency }}</div>
      }
      @if (showFinalisation()) {
        <div class="py-2 px-3 text-right font-semibold">{{ row.finalisationAmount | currency }}</div>
      }
      @if (showDayTrip()) {
        <div class="py-2 px-3 text-right bg-purple-100">{{ row.dayTripAmount | currency }}</div>
      }
      <div class="col-span-full h-[1px] bg-surface-200"></div>
    }
  </div>
</div>
